export default __webpack_public_path__ + "static/media/Mypage.7e02b57d75fc25b127113e1324d492b9.svg";